module.exports = __webpack_public_path__ + "img/car-handle-transparent.8d7b3e62.png";